import { useState } from 'react';
import { profile, validation } from 'lang/en.json';
import styles from 'styles/modules/SidescreenAddMediaC.module.scss';
import Input from 'components/Input';

const Details = (props) => {
    const { callback, register, errors } = props;
    const [formData, setFormData] = useState(props.data);

    const handleKeyUp = (name, val) => {
        let newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);

        callback(newFormData);
    };

    const inputs = [
        {
            label: profile.media_coverage.sidebar.coverage_source,
            name: 'source',
            color: 'dark',
            error: errors['source'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData.source,
        },
        {
            label: profile.media_coverage.sidebar.coverage_title,
            name: 'title',
            color: 'dark',
            error: errors['title'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData.title,
        },
        {
            label: profile.media_coverage.sidebar.coverage_url,
            name: 'url',
            color: 'dark',
            error: errors['url'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData.url,
        },
    ];

    return (
        <section className={styles.bio}>
            <div className={styles.bioBody}>
                {inputs.map((item, key) => {
                    return <Input {...item} key={`input-${key}`} />;
                })}
            </div>
        </section>
    );
};

export default Details;
